import React from 'react'
import { Dropdown } from 'react-bootstrap'

const SizePerPage = ({ currentSize, handleChange, ranges = [10, 25, 30, 50] }) => {
  return(
    <Dropdown>
      <Dropdown.Toggle variant='primary'>
        {currentSize}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {
          ranges.map( page => <Dropdown.Item href="#" key={page} onClick={() => handleChange(page) }>{page}</Dropdown.Item> )
        }
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default SizePerPage